import React, { useState } from "react";
import edit from "../../assets/images/icons/edit-2.png";
import trash from "../../assets/images/icons/trash.png";
import norecord from "../../assets/images/message-remove.png";
import PlusIMgDark from "../../assets/images/plusDark.png";
import { useSelector } from "react-redux";
import Toaster from "../../components/Toaster";
import MessageSegmentItem from "./MessageSegmentItem";

const MessageSegmentsList = ({
  data,
  handleRemoveMessageSegment,
  handleEditMessageSegment,
  handleOpenForm,
}) => {
  const userLogin = useSelector((state) => state.userLogin);

  return (
    <div id="tab-1" className="tab-content">
      <div className="tableInfo">
        <div className="listTables">
          {!data ||
            (data?.length > 0 && (
              <ul className="individualRow tableHead">
                <li className="mesageSegmentTitleHead">Title</li>
                <li className="messageSegmentBlocksHead">Message Blocks</li>
                <li className="messageSegmentActionHead">Action</li>
              </ul>
            ))}
          {!data ||
            (data?.length < 1 && (
              <ul className="individualRow tableContent noRecordsWraper">
                <li className="noRecord messageWrater">
                  <p>No Segments created.</p>
                  <span className="noImageWraper">
                    <img src={norecord} alt="" />
                  </span>
                  <button
                    style={{ margin: "25px auto" }}
                    className="createButton Lists"
                    id="autometion-create-btn"
                    onClick={handleOpenForm}
                  >
                    <img src={PlusIMgDark} className="plusImg" alt="" />
                    Add Sagement{" "}
                  </button>
                </li>
              </ul>
            ))}

          {data?.map((segment) => {
            return <MessageSegmentItem key={segment._id} segment={segment}
            handleRemoveMessageSegment={handleRemoveMessageSegment}
            handleEditMessageSegment={handleEditMessageSegment}
            />;
          })}
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default MessageSegmentsList;
